
import { Notification } from "@/hooks/useNotificationDetail";
import { NotificationProductData } from "@/types/notifications";
import { logWebhookResult } from "./webhookLogger";
import { sendWebhook } from "./webhookUtils";

/**
 * Send a webhook notification about recipients updates
 */
export const sendRecipientsWebhook = async (
  notification: Notification & { products?: NotificationProductData[] },
  internalRecipients: string[],
  externalRecipients: string[]
): Promise<boolean> => {
  const webhookUrl = "https://luijtenvvz.app.n8n.cloud/webhook/6ddcd5a7-6f6f-4352-aeab-dd32de11ea06";
  
  try {
    const payload = {
      notification_id: notification.id,
      vo_number: notification.vo_number,
      exact_order_number: notification.exact_order_number,
      type: notification.type,
      status: notification.status,
      priority: notification.priority,
      message: notification.message,
      user_id: notification.user_id,
      user_name: notification.user_name,
      created_at: notification.created_at,
      updated_at: notification.updated_at,
      archived: notification.archived,
      internal_recipients: internalRecipients,
      external_recipients: externalRecipients,
      products: notification.products || [],
      timestamp: new Date().toISOString()
    };
    
    const result = await sendWebhook({
      webhookUrl,
      payload,
      webhookType: 'email_recipients',
      entityId: notification.id,
      entityType: 'notification'
    });
    
    // If we get a successful response, log the webhook call
    if (result.success) {
      await logWebhookResult(
        notification,
        'email_recipients',
        webhookUrl,
        payload,
        result.responseStatus,
        result.responseText,
        true
      );
    }
    
    return result.success;
  } catch (error) {
    console.error("Unexpected error in recipients webhook service:", error);
    return false;
  }
};
